import { createVNode as a, mergeProps as i } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DefaultCircleFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (e, t) => {
  const l = {
    ...e,
    ...t.attrs
  };
  return a(d, i(l, {
    icon: o
  }), null);
};
r.displayName = "DefaultCircleFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
